<div class="confirmation-modal">
  <div class="modal">
    <div class="mask" (click)="cancelConfirmation()"></div>
    <div class="container">
      <div class="container__information">
        <div class="row issue">
          <div>
            <div class="issue-title">{{ order.issueID }}</div>
            <div class="issue-subtitle">
              {{ order.issueName?.toLowerCase() }}
            </div>
          </div>
          <div
            class="issue-image"
            *ngIf="order.issueIcon"
            [ngStyle]="{ 'background-image': 'url(' + order.issueIcon + ')' }"
          ></div>
        </div>

        <div class="row">
          <div class="left">Tipo de orden</div>
          <div class="right" data-recording-sensitive>
            {{ order.type }}
          </div>
        </div>

        <div class="row" *ngIf="!fractionalTitles">
          <div class="left">Títulos</div>
          <div class="right" data-recording-sensitive>
            {{ order.titles | hbCustomFormat: '0,0' }}
          </div>
        </div>

        <div class="row" *ngIf="fractionalTitles">
          <div class="left">
            Títulos {{ order.sellAllPosition ? '' : 'aproximados' }}
          </div>
          <div class="right" data-recording-sensitive>
            {{ order.titles | hbCustomFormat: '0,0.00000000' }}
          </div>
        </div>

        <div class="row" *ngIf="order.price">
          <div class="left">Precio</div>
          <div class="right" data-recording-sensitive>
            {{
              order.price
                | hbCustomFormat: (order.price < 1 ? '$0,0.000' : '$0,0.00')
            }}
          </div>
        </div>

        <div class="row" *ngIf="amount > 0">
          <div class="left">Monto</div>
          <div class="right" data-recording-sensitive>
            {{ amount | hbCustomFormat: (amount < 1 ? '$0,0.000' : '$0,0.00') }}
          </div>
        </div>

        <div class="row" *ngIf="order.targetPrice">
          <div class="left">Precio objetivo</div>
          <div class="right" data-recording-sensitive>
            {{
              order.targetPrice
                | hbCustomFormat
                  : (order.targetPrice < 1 ? '$0,0.000' : '$0,0.00')
            }}
          </div>
        </div>

        <div
          class="row"
          *ngIf="
            (order.typeId === 6 || order.typeId === 7) && order.algorithmTypeId
          "
        >
          <div class="left stop-loss">Stop loss</div>
        </div>

        <div
          class="row"
          *ngIf="
            (order.typeId === 6 || order.typeId === 7) && order.algorithmTypeId
          "
        >
          <div class="left">Tipo de orden</div>
          <div class="right" data-recording-sensitive>
            {{ order.algorithm }}
          </div>
        </div>

        <div class="row" *ngIf="order.stopPrice">
          <div class="left">Precio Stop</div>
          <div class="right" data-recording-sensitive>
            {{
              order.stopPrice
                | hbCustomFormat: (order.stopPrice < 1 ? '$0,0.000' : '$0,0.00')
            }}
          </div>
        </div>

        <div class="row" *ngIf="order.limitPrice">
          <div class="left">Precio Límite</div>
          <div class="right" data-recording-sensitive>
            {{
              order.limitPrice
                | hbCustomFormat
                  : (order.limitPrice < 1 ? '$0,0.000' : '$0,0.00')
            }}
          </div>
        </div>

        <div class="row" *ngIf="order.stopPercentage">
          <div class="left">Porcentaje</div>
          <div class="right" data-recording-sensitive>
            {{ order.stopPercentage / 100 | hbCustomFormat: '0.00%' }}
          </div>
        </div>

        <div class="row" *ngIf="order.triggerPrice">
          <div class="left">Precio Máximo</div>
          <div class="right" data-recording-sensitive>
            {{
              order.triggerPrice
                | hbCustomFormat
                  : (order.triggerPrice < 1 ? '$0,0.000' : '$0,0.00')
            }}
          </div>
        </div>

        <div class="row" *ngIf="order.bid">
          <div class="left">Puja</div>
          <div class="right" data-recording-sensitive>
            {{ order.bid / 100 | hbCustomFormat: '$0,0.000' }}
          </div>
        </div>

        <div class="row" *ngIf="order.partiality">
          <div class="left">Parcialidad</div>
          <div class="right" data-recording-sensitive>
            {{ order.partiality | hbCustomFormat: '0,0' }}
          </div>
        </div>

        <div class="row" *ngIf="order.vigency !== undefined">
          <div class="left">Vigencia</div>
          <div class="right" data-recording-sensitive>
            {{ order.vigency }} {{ order.vigency > 1 ? 'días' : 'día' }}
          </div>
        </div>

        <!-- Commission -->
        <div class="row" *ngIf="feeAmount !== undefined">
          <div class="left">Comisión</div>
          <div class="right" data-recording-sensitive>
            {{
              feeAmount
                | hbCustomFormat: (feeAmount < 1 ? '$0,0.000' : '$0,0.00')
            }}
          </div>
        </div>
        <!-- IVA -->
        <div class="row" *ngIf="ivaAmount !== undefined">
          <div class="left">IVA</div>
          <div class="right" data-recording-sensitive>
            {{
              ivaAmount
                | hbCustomFormat: (ivaAmount < 1 ? '$0,0.000' : '$0,0.00')
            }}
          </div>
        </div>

        <!-- Approximate total -->
        <div class="row approx-total" *ngIf="approxTotal !== undefined">
          <div class="left">Total aproximado</div>
          <div class="right" data-recording-sensitive>
            {{
              approxTotal
                | hbCustomFormat: (approxTotal < 1 ? '$0,0.000' : '$0,0.00')
            }}
          </div>
        </div>

        <div class="row" *ngIf="order.total !== undefined">
          <div class="left">
            Total {{ order.sellAllPosition ? 'aproximado' : '' }}
          </div>
          <div class="right" data-recording-sensitive>
            {{ order.total | hbCustomFormat: '$0,0.00' }}
          </div>
        </div>

        <div
          class="confirmation-modal__full-sell-notice information-card"
          *ngIf="fractionalTitles && order.sellAllPosition && !isOutOfTime"
        >
          <div class="information-card__container">
            <div
              class="information-card__leading-icon information-card__leading-icon--info"
            ></div>
            <div class="information-card__information">
              <p>
                Estás a punto de vender todos tus títulos de esta emisora y el
                total aproximado que recibirás puede variar dependiendo del
                cambio en el precio al efectuar la operación
              </p>
            </div>
          </div>
        </div>

        <div
          class="confirmation-modal__full-sell-notice information-card"
          *ngIf="fractionalTitles && order.sellAllPosition && isOutOfTime"
        >
          <div class="information-card__container">
            <div
              class="information-card__leading-icon information-card__leading-icon--info"
            ></div>
            <div class="information-card__information">
              <p>
                Estás a punto de vender todos tus títulos de esta emisora. El
                total aproximado que recibirás puede variar dependiendo del tipo
                de cambio y la actualización del precio al efectuar la operación
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="modal__actions">
        <button
          (click)="cancelConfirmation()"
          type="button"
          class="button button--small button--transparent"
          [class.button--disabled]="lockConfirmation"
        >
          Cancelar
        </button>
        <button
          *ngIf="!lockConfirmation"
          (click)="confirmation()"
          type="button"
          class="button button--small button--dark"
        >
          {{ copyCallToAction }}
        </button>
        <button
          *ngIf="lockConfirmation"
          class="button button--small button--dark button--loading button--disabled"
          disabled
        >
          <div class="button__loader">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
